// extracted by mini-css-extract-plugin
export default {"error":"form-error_error__r9ooA"};